import React from 'react';
import TooltipBody from 'modules/emergencies/components/ui/texts/TooltipBody';
import TooltipHeader from 'modules/emergencies/components/ui/texts/TooltipHeader';

export const BidTooltip = ({ content }) => {
  return (
    <>
      <TooltipHeader>Conditions</TooltipHeader>
      <TooltipBody>{content}</TooltipBody>
    </>
  );
};
